import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from "axios";
import {decode} from 'html-entities';
import ReactReadMoreReadLess from 'react-read-more-read-less'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import moment from "moment";
import { registerViewURL } from "../../../apis/urls";
import { $ } from "react-jquery-plugin";


const RegisterView = () => {

    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        RegisteringView();
    },[]
    );


    const { eventid,id } = useParams();
    const[ result,setResult ] = useState('');
    const[ dataResult,setDataResult ] = useState('');
    const[ count,setCount ] = useState('');

    let navigate = useNavigate();


    const RegisteringView = ()=>{
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const instance = axios.create({
            baseURL: registerViewURL+id,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            console.log(res.data)
            setDataResult(res.data)
            setResult(res.data.data);
          });

    }




    const DeleteEvent = () => {

        let r = window.confirm("Are you sure you want to delete this Register?");

        if(r == true){
            
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: registerViewURL+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
                navigate("/register_details/"+eventid)
            
            }).catch((error) =>{
                
                console.log('error',error.message)
            });
        }
    }


    return(
        <div>
            <aside class="right-side areas">    
                <div class="content-area dash-contentss">
                   
                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <i class="icon-library1"></i>
                            <h2 class="page-title">Seminar - {decode(dataResult.eventname)}</h2>
                        </div>

                        <div class="page-rightside-action-column"></div>
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to={"/conference"}>Seminar</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"> <Link to={"/register_details/"+eventid}>Attendees</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Attendee - {result.firstname+' '+result.lastname}</li>

                        </ol>
                    </nav>

                    <div className="jumbotron description-view">

                        <div id="generalinfo" class="container tab-pane active"><br/>
                            <div class="row tab-section">
                                <div class="col-md-3">
                                    <label>Name</label>
                                    <div>{result.firstname+' '+result.lastname}</div>
                                </div>

                                <div class="col-md-3">
                                    <label>Email</label>
                                    <div>{result.email}</div>
                                </div>

                                <div class="col-md-3">
                                    <label>Phone</label>
                                    <div>{result.phone}</div>
                                </div>



                                <div class="col-md-3">
                                    <label>Member School</label>
                                    <div>{decode(dataResult.schoolname)}</div>
                                </div>
                            
                                
                            </div>



                            {result.schoolid === 0?
                            <div class="row tab-section">
                                <div class="col-md-3">
                                    <label>Organization name</label>
                                    <div>{result.org_name?result.org_name:'-'}</div>
                                </div>
                                <div class="col-md-3">
                                    <label className="jobview-label">Organization city</label>
                                    <div>{result.org_city?result.org_city:'-'}</div>
                                </div>
                                <div class="col-md-3">
                                    <label>Organization state</label>
                                    <div>{result.org_state?result.org_state:'-'}</div>
                                </div>
                                <div class="col-md-3">
                                    <label>Organization country</label>
                                    <div>{result.org_country?result.org_country:'-'}</div>
                                </div>

                            </div>:null}



                            <div class="row tab-section">
                                <div class="col-md-3">
                                    <label>Created Date</label>
                                    <div>{moment(result.createdAt).format("MMMM DD, YYYY")}</div>
                                </div>
                                <div class="col-md-3">
                                    <label className="jobview-label">Number of Attendees</label>
                                    <div>{dataResult.attendees}</div>
                                </div>
                                <div class="col-md-3">
                                    <label>Registrants title at school</label>
                                    <div>{result.reg_title?result.reg_title:'-'}</div>
                                </div>

                            </div>


                            <div className="list-action-wrpr showicons roundicons-text">
									<div className="list-action-wrpr">
									{/* <Link to={"/edit_event/"+result.id} data-toggle="tooltip" title="Edit"><i  class="edit icon-pencil3"></i><span>Update</span></Link> */}
									<button onClick={DeleteEvent} style={{background:"#fff"}} data-toggle="tooltip" title="Delete"><a><i class="delete icon-close1"></i><span>Delete</span></a></button>
									</div>
								</div>
                                
                            
                        </div>

                    </div>
                    


                </div>
            </aside>

        </div>
    )
}

export default RegisterView;